import React, { useState } from "react";
import bgImg from "../assets/overview_pastandpresent_background.webp";
import Navigation from "../components/Navigation";
import x_button from "../assets/button/button_x.png";
import bg_book from "../assets/pastandpresent/referbook_past_background_row.png";
import bg_present from "../assets/pastandpresent/present_background_row.png";
import parentandchild from "../assets/pastandpresent/parentandchild.png";
import brothers from "../assets/pastandpresent/brothers.png";
import couple from "../assets/pastandpresent/couple.png";
import friends from "../assets/pastandpresent/friends.png";
import quiz_image from "../assets/pastandpresent/quiz_image.png";
import book_images from "../assets/pastandpresent/referbook";
import underline from "../assets/pastandpresent/underline.png";
import quiz_box from "../assets/pastandpresent/quizbutton.png";

const PastandPresent = () => {
  const [selectedKey, setSelectedKey] = useState(4);
  const [bookModal, setBookModal] = useState(false);
  const [pastModal, setPastModal] = useState(false);
  const [presentModal, setPresentModal] = useState(false);
  const [isClosedModal, setIsClosedModal] = useState(false);
  const [wrong, setWrong] = useState(null);
  const [show, setShow] = useState(false);
  const [clickChoice, setClickChoice] = useState(null);
  const [, setClosedRow] = useState(null);
  const [presentItem, setPresentItem] = useState(null);
  const [hover, setHover] = useState(null);
  const [bookHover, setBookHover] = useState(null);
  const colsTitle = ["○ 관점", "○ 관계", "○ 주제", "○ 의견", "○ 시기"];
  const pastTitle = ["관계", "주제", "문장", "출처"];
  const past = [
    [
      "부모자식",
      "안부인사",
      "어두운 새벽에 (시)부모의 처소에 나아가 아침 문안을 드린다. 자식은 약수를 올리고 며느리는 새벽에 아침 음식을 차린다.",
      "주자가례, 통례",
      "70px",
    ],
    [
      "부모자식",
      "안부인사",
      "닭이 처음 울면 모두 세수하고, 양치질하고 머리 빗고 비단으로 머리를 싸서 쪽찌고, 비녀 꽂고, 비단으로 머리를 묶어 쪽을 장식하고, 옷 입고 큰 \n띠를 띠고, 왼쪽과 오른쪽에 쓸 물건들을 차고, 향이 든 주머니를 차고, 신을 신고, 신의 끈을 맨다. 이와 같이 하고서 부모와 시부모가 계신 곳으\n로 아침 문안을 드리러 간다.",
      "소학, 명륜 제1장~4장",
      "130px",
    ],
    [
      "부모자식",
      "생리현상",
      "감히 구역질, 트림, 재채기, 기침을 하지 못하며, 하품하고 기지개 켜고, 한쪽 발로 비스듬히 서서 다른 물체에 몸을 의지하거나 곁눈질하여 보지 \n못하며, 감히 가래침을 뱉고 콧물을 흘리지 못한다.",
      "소학, 명륜 제1장~4장",
      "100px",
    ],
    [
      "부모자식",
      "의사결정",
      "항렬이 낮거나 어린 사람들은 일이 크고 작음에 상관없이 자기 멋대로 행하지 말고 반드시 가장에게 여쭈어야 한다.",
      "주자가례, 통례",
      "70px",
    ],
    [
      "부모자식",
      "외출보고",
      "사람의 자식이 된 자는 나갈 때 반드시 부모에게 그 갈 곳을 알리고, 돌아왔을 때는 반드시 부모를 뵙고 인사를 드리되, 그 안부를 눈여겨본다. 또 \n노는 곳도 반드시 정해져 있어 함부로 딴 곳에 가지 않고 익히는 바도 반드시 일정한 일이 있어 함부로 다른 일을 하지 않는다.",
      "주자가례, 통례",
      "100px",
    ],
    [
      "부모자식",
      "외출보고",
      '공자께서 말씀하셨다. "부모가 생존해 계시면 먼 데 가서 놀지 아니하고 놀더라도 반드시 일정한 곳이 있어야 한다."',
      "논어, 이인 제19",
      "70px",
    ],
    [
      "부모자식",
      "부모봉양",
      "효자의 부모를 섬김은 그 잠자리와 거처를 편안케 해드리며, 또 음식으로 성의껏 봉양해야 한다.",
      "소학, 명륜 제18장",
      "70px",
    ],
    [
      "부모자식",
      "부모봉양",
      "세속에서 말하는 불효에 다섯 가지가 있다. 사지를 게을리하여 부모의 봉양을 돌보지 않는 것이 첫째 불효다.",
      "소학, 명륜 제27장",
      "70px",
    ],
    [
      "부모자식",
      "부모봉양",
      "어버이 섬기는 것을 지극정성으로 하니 집이 가난하여 나물 음식을 먹으며 어버이를 위하여 백 리 밖의 쌀을 져 왔다.",
      "오륜행실도, 자로부미",
      "70px",
    ],
    [
      "부모자식",
      "후손",
      "불효에 세 가지가 있으니, 후손이 없는 것이 가장 크다.",
      "맹자, 이루장구 상 제27장",
      "70px",
    ],
    [
      "형제친척",
      "금전지원",
      "식이 전택과 재물을 모두 아우에게 주고 다만 기르던 양 백 여 마리를 가지고 홀로 산중에 들어가 십 여 년을 양을 쳐 양이 천여 마리에 이르러 논 \n밭과 집을 사두었다. 그 동생이 가산을 모두 탕진하자 식이 또 다시 동생에게 나누어 주었다.",
      "오륜행실도, 복식분축",
      "100px",
    ],
    [
      "형제친척",
      "금전지원",
      "즉시 나누어 가진 문서를 가져와 불태우고, 여러 열쇠를 다 형수에게 맡겼다. 또 저축하였던 돈으로 형의 빚을 다 갚으니 그 형이 부끄러워하다가\n 마지 못 하여 받았다.",
      "오륜행실도, 언소석적",
      "100px",
    ],
    [
      "형제친척",
      "병간호",
      '전염병이 크게 돌아 두 형이 다 염병으로 죽고 다른 형 또한 병이 들어 목숨이 위태로워 부모와 여러 자식이 모두 집밖으로 나갔으나 유곤이 혼자 \n가지 않자 아버지와 여러 형제가 피하라고 하니 유곤이 말하였다. "저는 본래 병을 두려워 하지 않습니다." 하고 그 형을 친히 붙들어 밤낮으로 \n자지 않고 간호하고, 또 죽은 형의 관을 어루만지며 슬피 울었다.',
      "오륜행실도, 유곤수병",
      "130px",
    ],
    [
      "형제진척",
      "형제관계",
      "형은 우애하고 아우는 공손하며, 형을 공경하는 마음이 윗 사람을 섬기는 수단이 된다",
      "소학, 가언 제14장",
      "70px",
    ],
    [
      "형제친척",
      "형제관계",
      "형 섬기기를 아버지와 같이 섬뎌 집안의 크고 작은 일을 다 형에게 물은 뒤에 행하였다",
      "오륜행실도, 채확자사",
      "70px",
    ],
    [
      "형제친척",
      "형제관계",
      "두 형은 연에게 사납게 대했는데 칼로 머리를 쳐 피가 흐르니 그의 고모가 두연을 숨겨주어 겨우 살아났다. (생략) 그 후 두연이 높은 벼슬자리에 \n올랐는데 맏형이 살아있어서 대접을 지극히 하고, 두 형과 고모, 계모의 자손들까지 두연의 음덕으로 벼슬한 사람들이 여럿이었다.",
      "오륜행실도, 두연대형",
      "100px",
    ],
    [
      "형제친척",
      "충고권면",
      '형이 고을 원님이 되어 남이 주는 것을 많이 받자 정균이 자주 형에게 간하였으나 형이 듣지 않았다. (생략) "재물은 다하여도 가히 다시 얻을 수 \n있지만 탐장의 죄를 지으면 죽을 때까지 벗어나지 못 합니다." 하니 형이 그 말에 감동하여 드디어 청렴한 사람이 되었다.',
      "오륜행실도, 자로부미",
      "100px",
    ],
    [
      "형제친척",
      "금전지원",
      "빈궁과 환난에 친척이 서로 구제하고, 혼인과 초상에 이웃이 서로 도와야 한다.",
      "소학, 가언 제14장",
      "70px",
    ],
    [
      "형제친척",
      "금전지원",
      "육촌 아유 경백의 내외가 흉년을 만나 먼 땅으로 팔려갔다. 이에 달지는 밭을 팔아 빚을 갚고, 재물과 집을 함께 가졌다.",
      "오륜행실도, 달지속제",
      "70px",
    ],
    [
      "형제친척",
      "가족상봉",
      "8대가 한집에 살아 집 사람이 백여명이 되지만 사이에 말이 없고 날마다 여러 부녀자가 한집에 모여 길쌈을 하고 일을 마치면 한 창고에 넣어 사\n사로이 감추는 것이 없었다. 어린 아이가 울면 여러 어머니들이 보는 대로 안아 젖을 먹이고, 한 어머니가 친정에 다니러 갈 때 그 자식을 두고 가\n면 모든 어머니들이 같이 젖을 먹여 누구의 아이인지를 묻지 않았고, 그 아이 또한 누가 자신의 어머니인 줄 몰랐다.",
      "오륜행실도, 장윤동찬",
      "130px",
    ],
    [
      "부부",
      "결혼",
      "남녀가 결합하는 것은 자연의 이치이고 하늘의 뜻이므로 결혼은 하늘의 뜻을 따르는 성스러운 행위이다. 남자는 16세에서 \n30세, 여자는 14세에서 20세에 한다.",
      "주자가례, 혼례",
      "100px",
    ],
    [
      "부부",
      "결혼",
      "남자 중에 직분이 없는 자가 없고, 여자 중에 시집 안 가는 자가 없었다",
      "예기, 예운",
      "70px",
    ],
    [
      "부부",
      "이혼재혼",
      "한번 혼례를 치르면 몸을 마칠 때까지 바꾸지 않는다. 그러므로 남편이 죽어도 시집가지 않는다.",
      "소학, 가연 제42장",
      "70px",
    ],
    [
      "부부",
      "이혼재혼",
      '"계집의 도리는 한 번 서방을 맞이하면 개가함이 없으니 의를 버리고 부귀를 따름은 더욱 사람의 도리가 아닙니다."',
      "오륜행실도, 고행할비",
      "70px",
    ],
    [
      "부부",
      "이혼재혼",
      '영씨는 황명 사람인데 유진아와 혼인을 정했으나 진이 죽으니 이때 영씨 나이가 16세였다. 부음을 듣고 슬피 울다가 부모에게 고하여 말하기를 \n"옛말에 열녀는 두 지아비를 섬기지 아니한다 하니 (생략) 시부모를 봉양하겠습니다."',
      "오륜행실도, 영녀정절",
      "100px",
    ],
    [
      "부부",
      "동고동락",
      "사위 될 사람이 진실로 현명하다면 지금은 비록 빈천하지만 훗날에 부귀하지 않는다고 어찌 알겠는가.",
      "소학, 가연 제42장",
      "70px",
    ],
    [
      "부부",
      "병간호",
      "지아비가 나쁜 병이 있었는데 어머니가 개가를 권하자 그녀가 말하기를 지아비의 불행함은 나의 불행함입니다. 계집이 한 번 서방을 맞으며 몸\n이 맞도록 고치지 아니하나니 불행하여 나쁜 병을 얻었다고 한들 큰 연괴가 없고 나를 버리지 아니하였거늘 내가 어찌 버리겠습니까?",
      "오륜행실도, 영녀정절",
      "100px",
    ],
    [
      "부부",
      "안부인사",
      "어두운 새벽에 (시)부모의 처소에 나아가 아침 문안을 드린다. 자식은 약수를 올리고 며느리는 새벽에 아침 음식을 차린다.",
      "주자가례, 통례",
      "70px",
    ],
    [
      "부부",
      "시부모봉양",
      '지아비가 과연 죽고 돌아오지 못하니 효부가 시어머니 봉양하기를 게을리 아니하여 마침내 개가할 뜻이 없으니 효부의 부모가 장차 데려가 개가\n하려 하니 효부가 말하기를 "지아비가 갈 때 내게 노모를 맡기었는데 내가 이미 그것을 허락하였습니다. 남의 노모를 봉양하다가 마치지 못하고 \n남에게 허락하고 능히 지키지 못하면 어찌 세상에 서겠습니까?"',
      "오륜행실도, 진씨양고",
      "130px",
    ],
    [
      "부부",
      "시부모봉양",
      "계집이 한 번 혼인하매 지아비가 죽어도 개가하지 않고 질삼하며 음식을 갖추어 시부모를 섬기는데 어찌 지아비 사랑이 예전만 못하다고 마음\n을 고치겠습니까?",
      "오륜행실도, 여종지체",
      "100px",
    ],
    [
      "친구",
      "안부연락",
      "평생 친한 벗은 중간에 혹시 소식이 끊어졌더라도 언제나 염두에 두었다가 서로 만나게 되면 반갑게 해야 하고 서먹서먹하여 무정한 듯 해서는 \n안 된다. 어릴 때 친한 벗이 장성한 뒤나 까닭 없이 서로 소원하게 되는 자가 있으니, 이는 천박한 사람이다. 이들은 빈천할 때 서로 버릴 것임을 \n반드시 알 수 있다.",
      "사소절, 교접",
      "130px",
    ],
    [
      "친구",
      "금전지원",
      "벗이 딱하거나 어려운 처지에 있을 때에는 더욱 그를 가까이 하고 도와야 하는 것이 우정이다.",
      "이이, 격몽요결",
      "70px",
    ],
    [
      "친구",
      "금전지원",
      "내가 부유하고 학문도 꽤 좋아하는데, 평소 절친한 친구 중에 굶주림에 허덕이면서도 나에게 빌려 달라고 입을 여는 사람이 한 명도 없다면 어찌 \n이상한 일이 아니겠는가.",
      "사소절, 교접",
      "100px",
    ],
    [
      "친구",
      "금전지원",
      "아비의 벗 여옹의 집에 들어갔는데 여옹이 죽었으나 가난하여 장사를 못 지내니 그 딸을 팔아 지내려 하였다. 사도가 행장을 풀어 그 돈을 다 주\n고 그 딸을 시집보냈다.",
      "오륜행실도, 사도경탁",
      "100px",
    ],
    [
      "친구",
      "대접",
      '벗인 여공이 갈 데가 없자 누호가 여공과 함께 밥을 먹고 누호의 아내가 여공의 아내와 함께 밥을 먹었다. 오랜 시간 후 처자가 싫어하니 누호가 울\n면서 꾸짖으며 말하기를, "여공은 옛 벗이라 늙고 궁박하여 나에게 와서 의탁하였으니 대접하는 것이 옳다." 하고 여공이 죽을 때까지 대접하였다.',
      "오륜행실도, 누호양여",
      "100px",
    ],
    [
      "친구",
      "충고권면",
      "벗 사이에는 간절하게 상대의 허물을 충고하고 착한 도리로 권면해야 한다.",
      "소학, 명륜 제90장",
      "70px",
    ],
    [
      "친구",
      "충고권면",
      '맹자께서 말씀하셨다. "책선은 벗의 도리이다."',
      "소학, 명륜 제91장",
      "70px",
    ],
    [
      "친구",
      "충고권면",
      '공자께서 말씀하셨다. "충고하여 선의 길로 인도하되, 듣지 않으면 그만두어서 자신을 욕되게 함이 없게 하라"',
      "소학, 명륜 제92장",
      "70px",
    ],
    [
      "친구",
      "예의",
      "아무리 친한 벗이라도 너나들이 해서는 안 된다. 어릴 때 사귄 처지라도 각기 장성한 뒤에는 그대로 아명을 불러서는 안 된다.",
      "사소절, 교접",
      "70px",
    ],
    [
      "친구",
      "예의",
      "오늘날의 이른바 벗들은 걸핏하면 서로 욕설을 하는 것으로 즐거움을 삼는다. 아들이니 손자니 하거나 말이니 소니 하며 서로 낮춰부른다. 또한 \n성명을 파자해서 아버지와 할아버지에게 침범하기도 한다. 추하고 패악한 말을 마구 주고받음으로써 인륜 도덕을 전연 무시한다. 그리고 그것을 \n예사로 여기지 않고 스스로 생각하기를 이와 같이 하지 않으면 친밀한 벗이 될 수 없다. 고 한다",
      "사소절, 교접",
      "130px",
    ],
    [
      "친구",
      "판단기준",
      '증자가 말하기를 "군자는 학문을 강론하는 일로 벗을 모으고, 벗의 선한 것을 본방아서 내 마음 공부에 도움이 되게 한다." 하였다.',
      "소학, 명륜 제90장",
      "70px",
    ],
    [
      "친구",
      "판단기준",
      '공자께서 말씀하셨다. "어느 나라에 살든 그 나라 대부 가운데 현명한 이를 섬기고, 그 나라 선비 가운데 어진 이를 벗으로 삼아야 한다.", 유익한 \n벗이 세 가지 있고, 해로운 벗이 세 가지 있다. 정직한 사람, 성실한 사람, 견문이 많은 사람을 벗으로 삼으면 유익하고, 겉치레만 잘하고 정직하\n지 못한 사람, 말만 잘하고 견문의 지혜가 없는 사람을 벗으로 삼으면 해롭다.',
      "소학, 명륜 제94장",
      "130px",
    ],
    [
      "친구",
      "겸손",
      '증자가 말했다. "능하면서도 능하지 못한 이에게 물으며, 아는 것이 많으면서도 적은 이에게 물으며, 있어도 없는 것처럼 여기며, 가득해도 빈 것\n처럼 여기며, 자신에게 잘못을 범해도 따지지 않는 것을, 옛날에 내 벗이 일찍이 이렇게 했었다."',
      "논어, 태백 제5장",
      "100px",
    ],
    [
      "사회",
      "이웃돕기",
      "머리털이 반백인 자가 길에서 물건을 머리에 이고, 등에 지지 않는다면 예의의 풍속이 될 것이다.",
      "소학, 가언 제14장",
      "70px",
    ],
    [
      "사회",
      "예의",
      "천천히 걸어서 어른의 뒤에 가는 것을 공손하다 하고, 빨리 걸어서 어른의 앞에 가는 것을 공손치 않다고 한다.",
      "소학, 명륜 제70장",
      "70px",
    ],
    [
      "사회",
      "예의",
      "나이가 갑절 많으면 아버지처럼 섬기고, 10년이 위라면 형처럼 섬기며, 5년 위라면 어깨를 나란히 하여 걷되 조금 뒤떨어져 따라간다.",
      "소학, 명륜 제72장",
      "70px",
    ],
    [
      "사회",
      "봉사기부",
      "얼제나 절약하고 검소해서 재물을 축적하며 능히 이를 흩어 남을 구제한다.",
      "예기, 곡례상",
      "70px",
    ],
    [
      "사회",
      "봉사기부",
      "재력을 가지고 가난한 자를 병탄하는 일이 없어야 한다.",
      "소학, 가언 제14장",
      "70px",
    ],
    [
      "사회",
      "봉사기부",
      "벼슬이 이미 높아 집 가까운 곳에 좋은 밭 수천 묘를 사두어 의장을 삼아 여러 가난한 종족을 구제하고, 종족 중 나이 많고 어진 사람 한 명을 골라 \n재물을 맡기고 한 사람 마다 날마다 쌀 한되와 해마다 비단 할 필씩을 주었다.",
      "오륜행실도, 중엄의장",
      "100px",
    ],
    [
      "사회",
      "겸손",
      '맹자께서 말씀하셨다. "벗을 사귈 때에는 내 나이 많은 것을 내세우지 말며, 내 몸이 존귀한 것을 내세우지 말며, 내 형제가 많은 것을 내세우지 말아야한\n다. 벗한다는 것은 상대방의 덕성을 벗하는 것이니 자신의 남다른 것을 믿어서 우월감을 가져서는 안된다."',
      "소학, 명륜 제95장",
      "100px",
    ],
    [
      "사회",
      "추모 의식",
      "효자가 어버이를 섬기는 것에는 세 가지 도가 있으니 살아서는 봉양하고 돌아가시면 상을 치르고 상이 끝나면 제사를 지낸다. 봉양에서 는 그의 \n유순함을 보고 상에서는 슬퍼하는것을 보고 제사에서는 공경하되 때에 맞게 하는 것을 본다. 이 세 가지 도리를 잘 하는 것이 효자의 행동이다.",
      "오륜행실도, 중엄의장",
      "100px",
    ],
    [
      "사회",
      "추모 의식",
      "부모가 살아 계실 때에도 예로써 섬기고 돌아가신 뒤에도 예로써 장사지내며 그리고 예로써 제사 지낼지어다. 조상에게 제사지낼 때 조상이 살\n아 계신 것 같이 할 것이니라.",
      "효경, 제22장",
      "100px",
    ],
    [
      "사회",
      "예의",
      "남자와 여자가 물건을 주고받는 것을 직접 하지 않는 것이 예의다.",
      "맹자, 이루장구 상 제17장",
      "70px",
    ],
    [
      "사회",
      "예의",
      "내가 계집이 되어 남에게 손을 잡히니 어찌 한 손으로써 몸을 더럽힐까? 하고 도끼로 그 팔을 찍어 버리니 보는 사람이 눈물을 아니 흘린 이가 없었다.",
      "소학, 가언 제14장",
      "70px",
    ],
  ];

  const present = [
    {
      title:
        "부모님과 따로 지낼 때, 부모님께 드리는 문안 인사의 적절한 빈도(전화 및 문자 포함)",
      choices: [
        "① 하루 한 번 이상",
        "② 2~3일에 한 번",
        "③ 1~2주에 한 번",
        "④ 한 달에 한 번",
      ],
      answer: [1],
      percent: [30, 37, 28, 6],
    },
    {
      title:
        "부모님 앞에서 하는 코풀기, 트림, 하품, 기지개는 예의에 어긋난다고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [17, 75, 9],
    },
    {
      title:
        "결정을 내리기 전, 부모님의 의견을 듣고 진행해야 한다고 생각하나요?",
      choices: [
        "① 사소한 결정도 의논해야 한다",
        "② 큰 결정에 대해서만 의논하면 된다",
        "③ 의논할 필요는 없다",
      ],
      answer: [1],
      percent: [11, 81, 9],
    },
    {
      title:
        "외출 전, 부모님께 돌아올 시간과 약속 장소를 말씀드리는 것이 예의라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [57, 24, 19],
    },
    {
      title: "부모님을 위한 물질적 지원은 당연히 이루어져야 한다고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [52, 28, 20],
    },
    {
      title: "자녀를 낳지 않이 것은 불효에 해당한다고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [11, 77, 13],
    },
    {
      title:
        "형제가 경제적으로 어려울 때 금전적으로 도와주는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [40, 45, 16],
    },
    {
      title:
        "형제가 큰 병/사고를 당했을 때 돌보고 책임지는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [68, 48, 15],
    },
    {
      title: "동생으로서 형/누나를 대접하는 문화에 대해 타당하다고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [39, 45, 17],
    },
    {
      title:
        "형제가 잘못된 행동을 한 경우, 충고하고 바른 행동을 권하는 것에 대해 어떻게 생각하나요?",
      choices: ["① 당연하다", "② 괜한 참견이다", "③ 모르겠다"],
      answer: [0],
      percent: [88, 6, 7],
    },
    {
      title:
        "가난과 어려움을 겪는 친척을 금전적으로 도와주는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [22, 54, 25],
    },
    {
      title: "명절날 친적들과 모여 시간을 보내는 것에 대해 어떻게 생각하나요?",
      choices: [
        "① 당연하다",
        "② 불편하다",
        "③ 모르겠다",
        "④ 기타 - 시간이 된다면 모이는 것도 괜찮다 등",
      ],
      answer: [1],
      percent: [53, 14, 25, 8],
    },
    {
      title: "결혼은 반드시 해야 한다고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [17, 75, 9],
    },
    {
      title: "이혼과 재혼에 대해 전반적으로 어떻게 생각하나요?",
      choices: [
        "① 긍정적이다",
        "② 부정적이다",
        "③ 재혼에만 부정적이다",
        "④ 모르겠다",
      ],
      answer: [0],
      percent: [57, 17, 5, 22],
    },
    {
      title:
        "배우자의 경제적 파산에 대한 책임을 지는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [53, 29, 19],
    },
    {
      title:
        "배우자가 큰 병/사고를 당했을 때 돌보고 책임지는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [93, 5, 3],
    },
    {
      title: "배우자 부모님께 드리는 문안 인사의 적절한 빈도를 선택해 주세요.",
      choices: [
        "① 2~3일에 한 번",
        "② 1~2주에 한 번",
        "③ 한 달에 한 번",
        "④ 모르겠다",
      ],
      answer: [2],
      percent: [7, 23, 40, 31],
    },
    {
      title:
        "배우자의 부모님을 자신의 부모님과 동등하게 생각하고 모시는 것을 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [54, 35, 12],
    },
    {
      title:
        "멀리 떨어져 지내는 친구와 적절하다고 생각되는 연락 빈도를 선택해 주세요.",
      choices: [
        "① 1~2주에 한 번",
        "② 한 달에 한 번",
        "③ 3~6개월에 한 번",
        "④ 1년에 한 번",
        "⑤ 용건이 있을때만",
      ],
      answer: [0],
      percent: [32, 30, 19, 6, 13],
    },
    {
      title:
        "친구가 경제적으로 어려울 때 금전적으로 도와주는 것을 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [1],
      percent: [13, 72, 16],
    },
    {
      title:
        "개인 사정으로 갈 곳 없는 친구가 우리 집에 머무를 수 있는 기간을 선택해 주세요.",
      choices: [
        "① 1~3일",
        "② 일주일 이내",
        "③ 한 달 이내",
        "④ 3개월 이내",
        "⑤ 일이 해결될 때까지 계속",
      ],
      answer: [1],
      percent: [29, 38, 14, 5, 15],
    },
    {
      title:
        "친구가 잘못된 행동을 한 경우, 충고하고 바른 행동을 권하는 것에 대해 어떻게 생각하나요?",
      choices: ["① 당연하다", "② 괜한 참견이다", "③ 모르겠다"],
      answer: [0],
      percent: [70, 19, 12],
    },
    {
      title: "친한 친구 사이에 허용되는 무례를 모두 선택해 주세요.",
      choices: [
        "① 직설적 말투",
        "② 욕설 사용",
        "③ 과격한 농담",
        "④ 개인 공간 침범",
        "⑤ 약속 어김",
        "⑥ 모두 안된다",
      ],
      answer: [0, 1, 2],
      percent: [25, 20, 20, 11, 16, 8],
    },
    {
      title: "적절하다고 생각되는 친구를 사귀는 판단 기준을 모두 선택해 주세요",
      choices: ["① 정직함", "② 성실함", "③ 선량함", "④ 똑똑함", "⑤ 유쾌함"],
      answer: [0, 2, 4],
      percent: [27, 17, 26, 6, 24],
    },
    {
      title:
        "주변에 어려운 상황에 처한 이웃을 돕는 것이 우리의 도덕적 의무라고 생각하나요?",
      choices: ["① 그렇다", "② 아니다", "③ 모르겠다"],
      answer: [0],
      percent: [67, 20, 24],
    },
    {
      title: "봉사와 기부가 우리 사회에서 강조되어야 하는 가치라고 생각하나요?",
      choices: [
        "① 공익을 위해 강조되어야 한다",
        "② 개인에게 맡겨야 하는 부분이다",
        "③ 모르겠다",
      ],
      answer: [1],
      percent: [35, 59, 7],
    },
    {
      title: "연장자에 대해 예우를 갖추는 문화에 대해 어떻게 생각하나요?",
      choices: [
        "① 누구나 마땅히 해야할 의무다",
        "② 긍정적이지만 의무가 아닌 선택이다",
        "③ 모르겠다",
      ],
      answer: [0],
      percent: [53, 44, 3],
    },
    {
      title:
        "길거리와 공원 등 공공장소에서 허용되는 스킨십의 범위를 모두 선택해 주세요.",
      choices: [
        "① 손 잡기",
        "② 어깨동무",
        "③ 허리 감싸 안기",
        "④ 가벼운 입맞춤",
        "⑤ 상관없다",
      ],
      answer: [0, 1],
      percent: [33, 28, 18, 12, 9],
    },
    {
      title:
        "자신을 낮춤으로써 타인을 존중하는 겸손을 강조하는 문화에 대해 어떻게 생각하나요?",
      choices: [
        "① 매우 긍정적이다",
        "② 긍정적이다",
        "③ 보통이다",
        "④ 부정적이다",
        "⑤ 매우 부정적이다",
      ],
      answer: [1],
      percent: [12, 38, 34, 16, 1],
    },
    {
      title: "돌아가신 조상을 기리는 제사에 대해 전반적으로 어떻게 생각하나요?",
      choices: [
        "① 긍정적이다",
        "② 거부감이 있다",
        "③ 모르겠다",
        "④ 기타 - 자신이 처한 상황에 맞게 하면 된다 등",
      ],
      answer: [2],
      percent: [34, 25, 39, 3],
    },
  ];

  const main = [
    [
      "전통유교",
      "부모·자식",
      "안부 인사",
      "매일 어두운 새벽, 부모님을 찾아가 아침 문안을 드리고 아침 음식을 차려야 한다.",
      "BC 5세기",
      parentandchild,
    ],
    [
      "전통유교",
      "부모·자식",
      "생리현상",
      "부모님 앞에서는 감히 구역질, 트림, 재채기, 기침, 하품, 기지개를 하면 안된다.",
      "1187년",
      parentandchild,
    ],
    [
      "전통유교",
      "부모·자식",
      "의사결정",
      "일이 크고 작음에 상관 없이 혼자 결정하지 말고 부모님께 여쭙고 진행 해야 한다.",
      "BC 5세기",
      parentandchild,
    ],
    [
      "전통유교",
      "부모·자식",
      "외출 보고",
      "외출을 할 때는 부모님께 가는 곳을 알려드려야 하며, 노는 곳도 일정한 곳이 있어야 한다.",
      "BC 5세기",
      parentandchild,
    ],
    [
      "전통유교",
      "부모·자식",
      "부모 봉양",
      "부모님의 잠자리와 거처를 편안하게 하며, 음식 으로 성의껏 봉양해야 한다.",
      "1187년",
      parentandchild,
    ],
    [
      "전통유교",
      "부모·자식",
      "후손",
      "후손을 남기지 않는 것은 가장 큰 불효다.",
      "BC 4세기",
      parentandchild,
    ],
    [
      "전통유교",
      "형제",
      "금전 지원",
      "형제가 경제적으로 어려울 때는 재산을 나누어 도와야 한다.",
      "1797년",
      brothers,
    ],
    [
      "전통유교",
      "형제",
      "병간호",
      "형제가 전염병에 걸려 목숨이 위태로울 때도 피하지 않고 밤낮으로 간호해야 한다.",
      "1797년",
      brothers,
    ],
    [
      "전통유교",
      "형제",
      "형제 관계",
      "형을 아버지와 같이 섬기고, 크고 작은 일을 형에게 물은 뒤 행해야 한다.",
      "1797년",
      brothers,
    ],
    [
      "전통유교",
      "형제",
      "충고·권면",
      "형제는 서로의 잘못된 행동을 바로잡고, 올바른 삶을 살도록 이끌어 줘야 한다.",
      "1797년",
      brothers,
    ],
    [
      "전통유교",
      "친척",
      "금전 지원",
      "빈궁과 환난에는 친척이 서로 구제해야 한다.",
      "1187년",
      brothers,
    ],
    [
      "전통유교",
      "친척",
      "가족 상봉",
      "매년 명절마다 일가친척이 모여 함께해야 한다.",
      "1797년",
      brothers,
    ],
    [
      "전통유교",
      "부부",
      "결혼",
      "남녀가 결합하는 것은 자연의 이치이고 하늘의 뜻이다.",
      "1759년",
      couple,
    ],
    [
      "전통유교",
      "부부",
      "이혼·재혼",
      "한번 혼례를 치르면 몸을 마칠 때까지 바꾸지 않는다. 그러므로 남편이 죽어도 시집가지 않는다.",
      "1187년",
      couple,
    ],
    [
      "전통유교",
      "부부",
      "동고동락",
      "장가들 때 가난했다가 나중에 부자가 되었다면 철거지악을 범한 아내 일지라도 버리지 못한다.",
      "1187년",
      couple,
    ],
    [
      "전통유교",
      "부부",
      "병간호",
      "지아비가 나쁜 병을 얻었다고 한들 지아비를 버리지 않는다.",
      "1797년",
      couple,
    ],
    [
      "전통유교",
      "부부",
      "안부 인사",
      "매일 어두운 새벽, 시부모를 찾아가 아침 문안을 드리고 며느리는 아침 음식을 차린다.",
      "BC 5세기",
      couple,
    ],
    [
      "전통유교",
      "부부",
      "시부모 봉양",
      "지아비가 죽어도 개가하지 않고 시부모를 섬겨야 한다.",
      "1797년",
      couple,
    ],
    [
      "전통유교",
      "친구",
      "안부 인사",
      "평생 친한 벗은 중간에 소식이 끊어졌더라도 언제나 염두에 두었다가 서로 만나게 되면 반갑게 해야 한다.",
      "1775년",
      friends,
    ],
    [
      "전통유교",
      "친구",
      "금전 지원",
      "의리가 중하고 재물이 가벼운 것은 가장 분명한 일이다.",
      "1797년",
      friends,
    ],
    [
      "전통유교",
      "친구",
      "대접",
      "옛 벗이 늙고 궁박하여 나한테 의탁하였다면 대접하는 것이 옳다.",
      "1797년",
      friends,
    ],
    [
      "전통유교",
      "친구",
      "충고·권면",
      "책선은 벗의 도리이다.",
      "1187년",
      friends,
    ],
    [
      "전통유교",
      "친구",
      "예의",
      "아무리 친한 벗이라도 너나들이 해서는 안 된다.",
      "1775년",
      friends,
    ],
    [
      "전통유교",
      "친구",
      "판단 기준",
      "정직한 사람, 성실한 사람, 견문이 많은 사람을 벗으로 삼으면 유익하다.",
      "1187년",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "이웃돕기",
      "머리털이 반백인 자가 길에서 물건을 머리에 이고, 등에 지지 않는 것이 예의의 풍속이다.",
      "1187년",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "연장자",
      "빨리 걸어서 어른의 앞에 가는 것은 공손치 않다.",
      "1187년",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "봉사·기부",
      "재물을 축적하면 이를 흩어 남을 구제해야 한다.",
      "BC 1세기",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "겸손",
      "자신의 남다른 것을 믿어서 우월감을 가져서는 안된다",
      "1187년",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "추모 의식",
      "제사란 생전에 봉양하던 마음을 이어서 효도를 계속하는 것이다.",
      "BC 4세기",
      friends,
    ],
    [
      "전통유교",
      "사회",
      "예의",
      "남자와 여자가 물건을 주고받는 것을 직접 하지 않는 것이 예의다.",
      "BC 4세기",
      friends,
    ],
  ];

  const quiz = [
    {
      row: 0,
      index: "첫 번째 퀴즈",
      title: "현대인들이 생각하는 부모님께 드리는 '문안인사'의 적절한 빈도는?",
      choices: [
        "하루 한 번 이상",
        "2~3일에 한 번",
        "1~2주에 한 번",
        "한 달에 한 번",
      ],
      answer: 1,
      explanation:
        "부모님께 2~3일에 한 번 정도 전화나 문자를 통해 \n문안 인사를 드리고 안부를 여쭙는 것이 적절하다는 의견이 많았어요.",
    },
    {
      row: 1,
      index: "두 번째 퀴즈",
      title:
        "현대인들은 부모님 앞에서 하는 코풀기, 트림, 하품, 기지개에 대해 어떻게 생각할까요?",
      choices: ["예의가 아니다", "문제없다"],
      answer: 1,
      explanation:
        "가족 간의 생리 현상은 예의의 문제가 아니라, \n자연스러운 일이라 생각하는 사람들이 많았어요.",
    },
    {
      row: 2,
      index: "세 번째 퀴즈",
      title:
        "현대인들은 결정을 내리기 전, 부모님의 의견을 묻는 것에 대해 어떻게 생각할까요?",
      choices: ["모든 일에 의논", "큰 문제만 의논", "안 해도 된다"],
      answer: 1,
      explanation:
        "큰 돈이 오가는 금전적 문제나 개명, 성형 같은 중요한 결정은 \n부모님과 의논해야 한다는 의견이 많았어요.",
    },
    {
      row: 3,
      index: "네 번째 퀴즈",
      title:
        "현대인들은 외출 전, 부모님께 약속 시간과 장소를 말씀드리는 것이 예의라고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "함께 사는 사람과 일정을 공유하는 것이 예의라는 의견이 많았으며, \n특히 약속이 늦어질 경우, 구체적으로 말해야 한다고 생각해요.",
    },
    {
      row: 4,
      index: "다섯 번째 퀴즈",
      title:
        "현대인들은 부모님을 위한 ‘물질적 지원’이 당연히 이루어져야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "자립 후 여유가 생기면 부모님께 용돈이나 여행으로 보답하는 것이 \n옳다는 의견이 많았어요.",
    },
    {
      row: 5,
      index: "여섯 번째 퀴즈",
      title: "현대인들은 자녀를 낳지 않는 것이 불효에 해당한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation:
        "자녀를 낳지 않는 것이 불효로 이어지는 것은\n아니라는 의견이 많았어요.",
    },
    {
      row: 6,
      index: "일곱 번째 퀴즈",
      title:
        "현대인들은 형제가 경제적으로 어려울 때, 금전적인 도움을 주어야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation: "형제간에도 금전적으로 도울 의무는 없다는 의견이 많았어요.",
    },
    {
      row: 7,
      index: "여덟 번째 퀴즈",
      title:
        "현대인들은 형제가 큰 병/사고를 당했을 때 돌보고 책임질 의무가 있다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "형제가 큰 병이나 사고를 당했을 때, 형제로서 책임을 져야\n한다는 의견이 많았어요.",
    },
    {
      row: 8,
      index: "아홉 번째 퀴즈",
      title:
        "현대인들은 동생으로서 형/누나를 대접하는 문화에 대해 타당하다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation:
        "형제는 동등한 관계여야 하며, 강제적인 요구나 심부름으로\n부담을 주면 안 된다는 의견이 많았어요.",
    },
    {
      row: 9,
      index: "열 번째 퀴즈",
      title:
        "현대인들은 형제가 잘못된 행동을 한 경우, 충고하는 것에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["당연하다", "참견이다"],
      answer: 0,
      explanation:
        "형제간에는 서로 충고하고 옳은 행동을 권유하는 것이\n당연하다는 의견이 많았어요.",
    },
    {
      row: 10,
      index: "열한 번째 퀴즈",
      title:
        "현대인들은 가난을 겪는 친척에게 금전적인 도움을 주어야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation:
        "친척 사이에도 금전적으로 돕는 것을 선호하지 않는 경우가 많았어요.",
    },
    {
      row: 11,
      index: "열두 번째 퀴즈",
      title:
        "현대인들은 명절날, 친척들과 모여 시간을 보내는 것에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["당연하다", "불편하다"],
      answer: 0,
      explanation:
        "여전히 명절은 가족과 친척들이 함께 시간을 보내며 정을 나누는\n소중한 시간으로 여겨지고 있어요.",
    },
    {
      row: 12,
      index: "열세 번째 퀴즈",
      title: "현대인들은 결혼은 반드시 해야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation:
        "개인의 가치관과 삶의 방식이 다양해지면서 결혼을 선택 사항으로\n보는 경향이 증가하고 있어요.",
    },
    {
      row: 13,
      index: "엘네 번째 퀴즈",
      title: "현대인들은 이혼과 재혼에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["긍정적이다", "부정적이다", "재혼에만 부정적"],
      answer: 0,
      explanation:
        "최근에는 이혼과 재혼을 자연스러운 삶의 과정으로 받아들이는\n경향이 강해지고 있어요.",
    },
    {
      row: 14,
      index: "열다섯 번째 퀴즈",
      title:
        "현대인들은 배우자의 경제적 파산에 대해 함께 책임져야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "배우자의 경제적 어려움도 함께 해결해야 할 문제로 받아들이는 것이\n옳다는 의견이 많았어요.",
    },
    {
      row: 15,
      index: "열여섯 번째 퀴즈",
      title:
        "현대인들은 배우자가 큰 병/사고를 당했을 때 돌보고 책임질 의무가 있다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "큰 병이나 사고를 당했을 때, 부부로서 서로 돌보고 책임을 져야\n한다는 의견이 많았어요.",
    },
    {
      row: 16,
      index: "열일곱 번째 퀴즈",
      title:
        "현대인이 생각하는 배우자 부모님께 드리는 ‘문안 인사’의 적절한 빈도는?",
      choices: ["1~2일에 한 번", "1~2주에 한 번", "한 달에 한 번"],
      answer: 2,
      explanation:
        "배우자의 부모님께 한 달에 한 번 정도 찾아뵙거나 전화를 통해 안부를\n여쭙는 것이 적절하다는 의견이 많았어요.",
    },
    {
      row: 17,
      index: "열여덟 번째 퀴즈",
      title:
        "현대인들은 배우자의 부모님을 자신의 부모님처럼 생각하고 모셔야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "배우자의 부모님을 존중하고 가족의 일원으로 받아들이는 것이\n결혼 생활의 중요한 부분으로 생각한다는 의견이 많았어요.",
    },
    {
      row: 18,
      index: "열아홉 번째 퀴즈",
      title:
        "현대인들이 생각하는 멀리 떨어져 지내는 친구와의 적잘한 연락 빈도는?",
      choices: [
        "1~2주에 한 번",
        "한 달에 한 번",
        "3~6개월에 한 번",
        "1년에 한 번",
      ],
      answer: 0,
      explanation:
        "부모님께 2~3일에 한 번 정도 전화나 문자를 통해\n문안 인사를 드리고 안부를 여쭙는 것이 적절하다는 의견이 많았어요.",
    },
    {
      row: 19,
      index: "스무 번째 퀴즈",
      title:
        "현대인들은 친구가 경제적으로 어려울 때, 금전적인 도움을 주어야 한다고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 1,
      explanation:
        "친구사이에 금전적으로 엮이는 것을 선호하지 않는 경우가 많았어요.",
    },
    {
      row: 20,
      index: "스물한 번째 퀴즈",
      title:
        "현대인이 생각하는 개인 사정으로 갈 곳 없는 친구가 자신의 집에 머물 수 있는 기간은?",
      choices: [
        "1~3일",
        "일주일이내",
        "한 달이내",
        "3개월이내",
        "일이 해결될 때까지",
      ],
      answer: 1,
      explanation:
        "오랜 기간 함께 지내는 것은 생활에 영향을 미칠 수 있기 때문에\n보통 일주일 정도가 적당하다고 생각해요.",
    },
    {
      row: 21,
      index: "스물두 번째 퀴즈",
      title:
        "현대인들은 친구가 잘못된 행동을 한 경우, 충고하는 것에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["당연하다", "참견이다"],
      answer: 0,
      explanation:
        "친구의 잘못된 행동을 바로잡는 것은 서로를 돕고 성장할 수 있는\n중요한 부분이라고 생각하는 경우가 많았어요.",
    },
    {
      row: 22,
      index: "스물세 번째 퀴즈",
      title:
        "현대인들이 생각하는 친한 친구 사이에 허용되는 무례 중 가장 많이 응답된 것은?",
      choices: [
        "직설적말투",
        "욕설사용",
        "과격한 농담",
        "개인 공간 침범",
        "약속 어김",
      ],
      answer: 0,
      explanation:
        "많은 사람들이 친한 친구 사이에서는 친밀감을 바탕으로 솔직하고\n직설적인 표현이 허용될 수 있다고 생각해요.",
    },
    {
      row: 23,
      index: "스물네 번째 퀴즈",
      title: "현대인들이 생각하는 친구를 사귈 때 가장 중요한 판단 기준은?",
      choices: ["정직함", "성실함", "선량함", "똑똑함", "유쾌함"],
      answer: 0,
      explanation:
        "많은 사람들이 친한 친구 사이에서는 친밀감을 바탕으로 솔직하고\n직설적인 표현이 허용될 수 있다고 생각해요.",
    },
    {
      row: 24,
      index: "스물다섯 번째 퀴즈",
      title:
        "현대인들은 주변에 어려운 상황에 처한 이웃을 돕는 것이 의무라고 생각할까요?",
      choices: ["그렇다", "아니다"],
      answer: 0,
      explanation:
        "이웃을 돕는 것이 공동체의 일원으로서 중요한 책임이라 여기는\n사람들이 많았어요.",
    },
    {
      row: 25,
      index: "스물여섯 번째 퀴즈",
      title: "현대인들은 봉사와 기부에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["강조되어야 한다", "개인의 선택이다"],
      answer: 1,
      explanation:
        "많은 사람들이 봉사와 기부를 강제적인 의무가 아닌, 개인의 가치관과\n상황에 따라 선택할 수 있는 활동으로 보고 있어요.",
    },
    {
      row: 26,
      index: "스물일곱 번째 퀴즈",
      title:
        "현대인들은 연장자에 대해 예우를 갖추는 행동에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["누구나 해야한다", "개인의 선택이다"],
      answer: 0,
      explanation:
        "연장자에 대한 존경과 예의를 갖추는 것은 사회적인 기본적인\n예의라고 생각해요.",
    },
    {
      row: 27,
      index: "스물여덟 번째 퀴즈",
      title: "현대인들이 생각하는 공공장소에서 허용되는 스킨십의 범위는?",
      choices: ["손잡기만", "어깨동무까지", "허리감싸기까지", "입맞춤까지"],
      answer: 1,
      explanation:
        "어깨동무까지가 공공장소에서 과한 스킨십을 피하면서 친밀감을\n표현할 수 있는 범위로 여겨지고 있어요.",
    },
    {
      row: 28,
      index: "스물아홉 번째 퀴즈",
      title:
        "현대인들은 겸손을 강조하는 문화에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["긍정적이다", "부정적이다"],
      answer: 0,
      explanation:
        "많은 현대인들은 겸손은 사회적 협력을 이루는 데 중요한 가치로\n생각하고 이를 통해 건강한 인간 관계를 유지하려고 해요.",
    },
    {
      row: 29,
      index: "서른 번째 퀴즈",
      title: "현대인들은 제사에 대해 어떤 의견을 가지고 있을까요?",
      choices: ["긍정적이다", "거부감있다", "모르겠다"],
      answer: 2,
      explanation:
        "제사에 대한 의견이 다양하고, 전통적인 의식에 대한 인식이 세대와\n개인에 따라 다르기 때문에 확고한 입장을 갖지 못한 사람이 많았어요.",
    },
  ];

  const book = [
    {
      name: "논어(論語)",
      content:
        "춘추시대 사상가 공자와 그 제자들의 언행을 기록한 유교 경전으로, 공자의 말, 공자와 제자 사이의 대화, 공자와 당시 사람들과의 대화, 제자들의 말, 제자들간의 대화로 구성되어 공자의 사상과 행동을 보여준다.",
      year: "저작연대 | BC 5세기",
      author: "저자 | 공자의 제자들",
      hover: "<논어/주희집주논어>, 한국민족문화대백과사전",
      image: book_images["nonuh1.png"],
      image2: book_images["nonuh2_row.png"],
    },
    {
      name: "맹자(孟子)",
      content:
        "전국시대 사상가 맹자의 언행을 기록한 유교 경전으로, 공자의 가르침을 보완 및 확장해 공자의 인(仁)에 의(義)를 덧붙여 인의를 강조하고 왕도정치를 말했으며 성선설을 주장했다.",
      year: "저작연대 | BC 4세기",
      author: "저자 | 맹자와 그 제자들",
      hover: "<맹자>, 한국민족문화대백과사전",
      image: book_images["mangja1.png"],
      image2: book_images["mangja2_row.png"],
    },
    {
      name: "예기(禮記)",
      content:
        "고대 중국의 예에 관한 기록과 해설을 정리한 유교경전으로, 공자 사후, 예를 숭상하던 스승의 뜻을 존숭한 그 제자들에 의해 예에 대한 기록이 쌓여 한나라에 이르러서는 200여 편이나 되었다.",
      year: "저작연대 | BC 1세기",
      author: "저자 | 공자의 제자들",
      hover: "<예기집설>, 한국민족문화대백과사전",
      image: book_images["aegi1.png"],
      image2: book_images["aegi2.png"],
    },
    {
      name: "대학(大學)",
      content:
        "주희가 유학 경전인 『예기』에서 『중용』과 『대학』을 독립시켜 사서(『논어』, 『맹자』, 『중용』, 『대학』) 중심의 체재를 확립했다. 그 중 대학은 유가의 근본이념을 일관된 체계로 정립한 유교 경전이다.",
      year: "저작연대 | 12세기",
      author: "저자 | 자사(子思))",
      hover: "<대학>, 한국민족문화대백과사전",
      image: book_images["daehak1.png"],
      image2: book_images["daehak2.png"],
    },
    {
      name: "중용(中庸)",
      content:
        "중용은 유교의 철학적 배경과 진리를 밝히고 있기 때문에 흔히 유교의 철학 개론서라 일컬어진다. 전반부는 '중용' 또는 '중화 사상'을 다루며 후반부는 우주 만물 운행의 원리를 설명한다.",
      year: "저작연대 | 12세기",
      author: "저자 | 자사(子思))",
      hover: "<중용장구대전>, 한국민족문화대백과사전",
      image: book_images["jungyong1.png"],
      image2: book_images["jungyong2.png"],
    },
    {
      name: "소학(小學)",
      content:
        "주희가 간행한 저서로, 통상 ‘주자가례’라 부른다. 이는 사대부들이 준수할 예법과 의례를 정리할 목적으로 편찬했으며 이후 조선에도 적용되어 국가와 사대부가 생활의 근간이 되었다.",
      year: "저작연대 | 1187년",
      author: "저자 | 주희(朱熹)",
      hover: "<해동소학>, 한국민족문화대백과사전",
      image: book_images["sohak1.png"],
      image2: book_images["sohak2.png"],
    },
    {
      name: "삼강행실도(三綱行實圖)",
      content:
        "세종이 아버지를 살해한 사건에 대해 엄벌에 앞서 효행의 풍습을 알리기 위해 충신, 효자, 열녀의 행실을 모아 편찬한 교훈서로, 모든 백성이 쉽게 이해할 수 있도록 매 편마다 그림을 넣었다.",
      year: "저작연대 | 1434년",
      author: "저자 | 설순(偰循) 등 집현전 학자들",
      hover: "<삼강행실도>, 한국민족문화대백과사전",
      image: book_images["samgang1.png"],
      image2: book_images["samgang2.png"],
    },
    {
      name: "이륜행실도(二倫行實圖)",
      content:
        "유교의 기본 윤리인 오륜 중에서 장유와 붕우의 이륜을 민간에 가르치기 위해 저술된 교재로, 조선 전기 극도로 문란해진 정치 질서를 바로잡기 위해 중종이 문신 조신에 명을 내려 편찬되었다.",
      year: "저작연대 | 1518년",
      author: "저자 | 조신 (曺伸)",
      hover: "<이륜행실도>, 한국민족문화대백과사전",
      image: book_images["leelun_row.png"],
    },
    {
      name: "가례(家禮)",
      content:
        "성리학을 집대성한 학자 주희가 간행한 저서로, 통상 ‘주자가례’라 부른다. 이는 사대부들이 준수할 예법과 의례를 정리할 목적으로 편찬했으며 이후 조선에도 적용되어 국가와 사대부가 생활의 근간이 되었다.",
      year: "저작연대 | 1759년",
      author: "저자 | 주희(朱熹)",
      hover: "<주자가례>, 한국민족문화대백과사전",
      image: book_images["garae1.png"],
      image2: book_images["garae2.png"],
    },
    {
      name: "사소절(士小節)",
      content:
        "조선후기 실학자 이덕무가 일상생활에서의 예절과 수신에 관하여 저술한 수양서로, 선비·부녀자·아동교육 등 일상생활의 예절과 수신에 관한 교훈을 예시를 들어 당시의 풍속에 맞춰 설명한다.",
      year: "저작연대 | 1775년",
      author: "저자 | 이덕무 (李德懋)",
      hover: "<사소절>, 한국민족문화대백과사전",
      image: book_images["sasojul1.png"],
      image2: book_images["sasojul2_row.png"],
    },
    {
      name: "오륜행실도(五倫行實圖)",
      content:
        "『삼강행실도』와 『이륜행실도』를 합책하여 편찬한 수양서로, 서문에서 정조는 “삼강, 이륜이라는 책이 백성을 감화시키고 풍속을 좋게 이룩한 근본이 되었다고 여겨서 책을 간행한다”고 밝혔다.",
      year: "저작연대 | 1797년",
      author: "저자 | 이병모(李秉模)",
      hover: "<오륜행실도>, 한국민족문화대백과사전",
      image: book_images["ohlun.png"],
    },
  ];

  const rows = 31;
  const cols = 5;
  const [clickedRow, setClickedRow] = useState({ row: null });

  const handleBookModal = () => {
    // setIsClosing(true);
    // setTimeout(() => {
    //   setBookModal(false);
    //   setIsClosing(false);
    // }, 100);
    setBookModal(!bookModal);
  };

  const handlePastModal = () => {
    // setIsClosing(true);
    // setTimeout(() => {
    //   setPastModal(false);
    //   setIsClosing(false);
    // }, 100);
    setPastModal(!pastModal);
  };

  const handlePresentModal = () => {
    // setIsClosing(true);
    // setTimeout(() => {
    //   setPresentModal(false);
    //   setIsClosing(false);
    // }, 100);
    setPresentModal(!presentModal);
  };

  const tableData = [];
  for (let i = 0; i < rows; i++) {
    const row = [];
    for (let j = 0; j < cols; j++) {
      const index = i * cols + j;
      row.push(main[index] ? main[index] : "");
    }
    tableData.push(row);
  }

  const handleQuiz = (rowIndex) => {
    return () => {
      // 클릭한 행이 이미 클릭된 행이라면 클릭한 행 해제
      if (clickedRow.row === rowIndex) {
        setIsClosedModal(true);
        setTimeout(() => {
          setClickedRow({ row: null });
          setWrong(null);
          setClickChoice(null);
          setShow(false);
          setIsClosedModal(false);
          setHover(rowIndex);
        }, 300);
      }
      // 클릭한 행이 다른 행이 클릭된 상태라면 클릭한 행 업데이트
      else {
        if (clickedRow.row !== null) {
          setClosedRow(clickedRow.row); // 기존 행 닫기
          setIsClosedModal(true);
          setTimeout(() => {
            setIsClosedModal(false);
            setClickedRow({ row: rowIndex });
            setHover(null);
            setWrong(null);
            setClickChoice(null);
            setShow(false);
          }, 300);
        } else {
          setClickedRow({ row: rowIndex });
          setHover(null);
          setWrong(null);
          setClickChoice(null);
          setShow(false);
        }
      }
    };
  };

  const mainHover = (rowIndex) => {
    if (clickedRow.row === null || clickedRow.row !== rowIndex) {
      setHover(rowIndex); // Hover 상태가 변경될 때만 업데이트
    }
  };

  const mainLeave = () => {
    setHover(null); // Hover 상태 해제
  };

  const handleChoice = (rowIndex, choiceIndex) => {
    return () => {
      setClickChoice(choiceIndex);
      if (quiz[rowIndex].answer === choiceIndex) {
        setWrong(false);
        setTimeout(() => {
          setShow(true);
        }, 1000);
      } else {
        setWrong(true);
        setTimeout(() => {
          setShow(true);
        }, 1000);
      }
    };
  };

  const closedModal = (type) => {
    if (type === "book") {
      setIsClosedModal(true);
      setTimeout(() => {
        setBookModal(false);
        setIsClosedModal(false);
      }, 400);
    }
    if (type === "past") {
      setIsClosedModal(true);
      setTimeout(() => {
        setPastModal(false);
        setIsClosedModal(false);
      }, 400);
    }
    if (type === "present") {
      setIsClosedModal(true);
      setTimeout(() => {
        setPresentModal(false);
        setIsClosedModal(false);
      }, 400);
    }
  };

  return (
    <>
      {bookModal && (
        <div className="book-modal-container">
          <div
            className="book-modal-content"
            style={
              isClosedModal && bookModal
                ? { animation: "slideModalUp 0.3s forwards" }
                : {}
            }
          >
            <div className="book-modal-title">
              <span>***  </span> 참고 서적에서는 프로젝트 진행에 활용된 유교
              서적들을 확인할 수 있습니다. <span>  ***</span>
            </div>
            <img src={bg_book} className="book-image" loading="lazy" alt="참고 서적 배경" />
            <div className="book-content">
              <div className="book-content-border">
                <div className="book-modal-shadow-left"></div>
                {book.map((item, index) => (
                  <div
                    key={index}
                    className="book-item"
                    onMouseEnter={() => setBookHover(index)}
                  >
                    {bookHover === index && (
                      <div
                        className="book-item-hover"
                        onMouseLeave={() => setBookHover(null)}
                      >
                        {item.hover}
                      </div>
                    )}
                    <div className="book-text">
                      <div className="book-item-title">{item.name}</div>
                      <div className="book-item-content">{item.content}</div>
                      <div className="book-item-year">
                        <div>{item.year}</div>
                        <div>{item.author}</div>
                      </div>
                    </div>
                    <div className="book-item-image">
                      <img src={item.image} loading="lazy" alt={item.name} />
                      {(item.image2 !== null) && (item.image2 !== 0) && (
                        <img src={item.image2} loading="lazy" alt={`${item.name} 추가 이미지`} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <img
              src={x_button}
              className="x-button"
              onClick={() => closedModal("book")}
              alt="닫기"
            />
          </div>
        </div>
      )}
      {pastModal && (
        <div className="book-modal-container">
          <div
            className="book-modal-content"
            style={
              isClosedModal && pastModal
                ? { animation: "slideModalUp 0.3s forwards" }
                : { height: "714px" }
            }
          >
            <div className="book-modal-title">
              <span>***  </span> 과거 자료에서는 유교 서적에서 발췌한 문장들을
              소개합니다. 각 주제에 대한 유교의 고전적 시각을 살펴보세요.
              <span>  ***</span>
            </div>
            <img
              src={bg_book}
              className="book-image"
              style={{ height: "713px" }}
              loading="lazy"
              alt="과거 자료 배경"
            />
            <div className="past-titles">
              {pastTitle.map((title, index) => (
                <div key={index} className={`past-title-${index}`}>
                  {title}
                </div>
              ))}
            </div>
            <div className="past-container-border">
              <div className="past-container">
                <div className="past-content">
                  {past.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className="past-row"
                      style={{
                        background: rowIndex % 2 !== 0 && "#00CDDA",
                        height: row[4],
                      }}
                    >
                      {row.slice(0, -1).map((cell, cellIndex) => (
                        <div
                          key={cellIndex}
                          className={`past-cell-${cellIndex}`}
                        >
                          {cell}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <img
              src={x_button}
              className="x-button"
              onClick={() => closedModal("past")}
              alt="닫기"
            />
          </div>
        </div>
      )}
      {presentModal && (
        <div className="present-modal-container">
          <div
            className="present-modal-content"
            style={
              isClosedModal && presentModal
                ? { animation: "slideModalLeft 0.3s forwards" }
                : {}
            }
          >
            <div className="present-modal-title">
              <span>***  </span> 현재 자료에서는 유교 속 모범 행동에 대한 현대
              사람들의 의견을 연구한 설문조사 결과를 제공합니다.
              <span>  ***</span>
            </div>
            <img src={bg_present} className="present-image" loading="lazy" alt="현재 자료 배경" />
            <div className="present-content">
              <div className="present-content-border">
                <div className="present-modal-shadow"></div>
                {present.map((item, index) => (
                  <div
                    key={index}
                    className="present-item"
                    onMouseEnter={() => setPresentItem(index)}
                    onMouseLeave={() => setPresentItem(null)}
                  >
                    <div
                      className={`present-item-title${presentItem === index ? "-hover" : ""
                        }`}
                    >
                      <div className="present-item-num">{index + 1}</div>
                      <div style={{ paddingLeft: "15px" }}>{item.title}</div>
                    </div>
                    <div className="present-item-content">
                      <table className="present-item-choices">
                        <tbody>
                          {item.choices.map((choice, i) => (
                            <tr
                              className={`present-item-row${presentItem === index &&
                                item.answer.includes(i) &&
                                "-hover"
                                }`}
                              key={i}
                            >
                              <td className="present-item-choice">{choice}</td>
                              <td className="present-item-percent">
                                {item.percent[i]}%
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <img
              src={x_button}
              style={{
                position: "absolute",
                width: "48px",
                height: "48px",
                left: "818px",
                cursor: "pointer",
              }}
              onClick={() => closedModal("present")}
              alt="닫기"
            />
          </div>
        </div>
      )}
      <div className="background">
        <Navigation selectedKey={selectedKey} setSelectedKey={setSelectedKey} />
        <img className="background-image" src={bgImg} fetchpriority="high" alt="과거와 현재 배경" />

        {hover !== null && clickedRow.row === null && (
          <div className="hover-image-container">
            <img className="hover-image" src={main[hover][5]} loading="lazy" alt="미리보기" />
          </div>
        )}
        <div
          className="title"
        // style={{
        //   cursor: "url(`/assets/cursor_default.png`) 64 64, auto !important",
        // }}
        >
          <div
            className="pp-btn"
            style={{
              left: "60px",
              // cursor: "url(`/assets/cursor_click.png`) 64 64, auto !important",
            }}
            onClick={handlePastModal}
          >
            과거 자료 보기▼
          </div>
          <div
            className="pp-btn"
            style={{
              left: "196px",
              // cursor: "url(`/assets/cursor_click.png`) 64 64, auto !important",
            }}
            onClick={handlePresentModal}
          >
            현재 자료 보기▼
          </div>
          <span>***  </span>
          다양한 주제에 대한 전통 유교 이념을 확인하고, 퀴즈를 통해 현대의
          시각도 함께 알아보세요.
          <span>  ***</span>
          <div
            className="pp-btn"
            style={{
              top: "11px",
              left: "2264px",
              // cursor: "url(`/assets/cursor_click.png`) 64 64, auto !important",
            }}
            onClick={handleBookModal}
          >
            참고 서적 보기▼
          </div>
        </div>
        <div className="pp-container">
          <div className="pp-title-container">
            {colsTitle.map((col, index) => (
              <div className={`pp-title-${index}`} key={index}>
                {col}
              </div>
            ))}
          </div>
          <div className="pp-shadowbar"></div>
          <div className="pp-content">
            <div>
              {main.map((row, rowIndex) => (
                <div key={rowIndex} className="pp-row-container">
                  <div
                    className="pp-row"
                    onClick={handleQuiz(rowIndex)}
                    onMouseEnter={() => mainHover(rowIndex)}
                    onMouseLeave={() => mainLeave()}
                    style={
                      clickedRow.row === rowIndex || hover === rowIndex
                        ? { background: "#00CDDA" }
                        : {}
                    }
                  >
                    {row.slice(0, -1).map((cell, colIndex) => (
                      <div
                        key={colIndex}
                        className={`pp-cell-${hover === rowIndex || clickedRow.row === rowIndex
                          ? "hover-" + colIndex
                          : colIndex
                          }`}
                      >
                        {(hover === rowIndex || clickedRow.row === rowIndex) &&
                          colIndex === 3 && (
                            <div className="right-triangle"></div>
                          )}
                        {cell}
                        {(hover === rowIndex || clickedRow.row === rowIndex) &&
                          colIndex === 3 && (
                            <div className="left-triangle"></div>
                          )}
                      </div>
                    ))}
                  </div>
                  {clickedRow.row === rowIndex && (
                    <div
                      className="quiz-container"
                      style={
                        isClosedModal &&
                          !bookModal &&
                          !pastModal &&
                          !presentModal
                          ? { animation: "quizClose 0.3s forwards" }
                          : {}
                      }
                    >
                      <img className="quiz-image" src={quiz_image} loading="lazy" alt="퀴즈 배경" />
                      {quiz
                        .filter((item) => item.row === clickedRow.row)
                        .map((item, index) => (
                          <div key={index} className="quiz-content">
                            {wrong === null && (
                              <div className="quiz-index">{item.index}</div>
                            )}
                            {wrong === false && (
                              <div className="quiz-title-right">
                                정답입니다!
                              </div>
                            )}
                            {wrong === true && (
                              <div className="quiz-title-wrong">아쉬워요!</div>
                            )}
                            <img src={underline} className="quiz-underline" loading="lazy" alt="" />
                            {show === false && (
                              <div className="quiz-title">Q. {item.title}</div>
                            )}
                            {show === false && (
                              <div className="quiz-choices">
                                {item.choices.map((choice, choiceIndex) => (
                                  <div
                                    key={choiceIndex}
                                    className={`quiz-choice${clickChoice === null ||
                                      clickChoice !== choiceIndex
                                      ? ""
                                      : choiceIndex === clickChoice &&
                                        wrong === true
                                        ? "-wrong"
                                        : "-right"
                                      }`}
                                    style={{
                                      backgroundImage: `url(${quiz_box})`,
                                    }}
                                    onClick={handleChoice(
                                      rowIndex,
                                      choiceIndex
                                    )}
                                  >
                                    <>
                                      <div className="quiz-choice-index">
                                        {choiceIndex + 1}
                                      </div>
                                      <div className="quiz-choice-text">
                                        {choice}
                                      </div>
                                    </>
                                  </div>
                                ))}
                              </div>
                            )}
                            {show === true && (
                              <div className="quiz-explanation">
                                <span>"{item.choices[item.answer]}"</span>
                                <div className="dot"> </div>
                                <div className="dot"> </div>
                                <div className="dot"> </div>
                                <span>{item.explanation}</span>
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PastandPresent;
